import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { retry, tap } from 'rxjs/operators';

import { InstanceDto } from '@plugins/usersync-lib/instance';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private readonly http = inject(HttpClient);
  public instance!: InstanceDto;

  fetchInstance(): Observable<InstanceDto> {
    return this.http.get<InstanceDto>('/api/instance').pipe(
      retry({ delay: 7000 }),
      tap((instance) => (this.instance = this.mapInstance(instance))),
    );
  }

  updateInstance(instance: InstanceDto): Observable<InstanceDto> {
    return this.http
      .patch<InstanceDto>('/api/instance', { instance })
      .pipe(tap((updated) => (this.instance = this.mapInstance(updated))));
  }

  startJob(): Observable<void> {
    return this.http.get<void>('/api/instance/startjob');
  }

  downloadJobInfo(jobId: string): Observable<Blob> {
    return this.http.get<Blob>('/api/instance/download/' + jobId, {
      responseType: 'blob' as 'json',
    });
  }

  private mapInstance(instance: InstanceDto): InstanceDto {
    // mapping jobs date strings to date type
    return {
      ...instance,
      jobs:
        instance.jobs?.map((job) => ({
          ...job,
          startDate: new Date(job.startDate),
          endDate: job.endDate ? new Date(job.endDate) : undefined,
        })) || [],
    };
  }
}
